import "Styles/templates/page.figment.scss";
import LazyVideo from '../components/lazy-video';
import PlayPauseVideo from "../components/play-pause-video";
import ParallaxEffect from '../components/parallax-effect';
import ProductCardNew from '../vue/product-card-new/index';

LazyVideo();
PlayPauseVideo();
ParallaxEffect();
ProductCardNew();